export default {
  forgot_password: "¿Olvidaste la contraseña?",
  click_here: "Haz un clic acá",
  about_us_text:
    "La devOZ desarrolla softwares enfocados a facilitar el mapeo de datos georeferenciados, com la intención de producir informaciónes inteligentes, para decisiones estratégicas.",
  about_us: "Sobre nosotros",
  user: "Usuario",
  change_map: "Cambiar mapa",
  dashboard: "Dashboard",
  feedback: "Feedback",
  experience_feedback: "Cuéntenos cómo va su experiencia :)",
  update_password: "Actualizar contraseña",
  info_username: "Recuperación de contraseña",
  recover_msg: "Ingrese su dirección de correo electrónico a continuación:",
  assistant: "Asistente de registro",
  other_country: "Otro país",
  search_providers: "Encontrarse Proveedores",
  active: "Activo",
  create_polygon: "Habilitar el modo de creación de área de servicio",
  erase_polygon: "Eliminar área de servicio",
  name_area_placeholder: "Nombre del área de cobertura dibujada:",
  name_area: "Nombre de área:",
  temporarily_unavailable: "Temporalmente no disponible",
  integration: "Integración",
  area: "Área",
  clicks: "Clics",
  save: "Guardar",
  options: "Opciones",
  fields: {
    name: {
      label: "Nombre",
      placeholder: "Ingresa su nombre",
    },
    provider_name: {
      label: "Nombre del proveedor",
      placeholder: "Ingresa el nombre de su proveedor",
    },
    user_name: {
      label: "Nombre completo",
      placeholder: "Ingrese su nombre completo",
    },
    user_email: {
      label: "Correo electrónico del usuario",
      placeholder: "Ingrese el correo electrónico del usuario",
    },
    cnpj: {
      label: "CNPJ",
      placeholder: "Ingresa su CNPJ",
    },
    username: {
      label: "Usuario",
      placeholder: "Ingresa su usuario",
    },
    password: {
      label: "Contraseña",
      placeholder: "Ingresa su contraseña",
    },
    password_confirm: {
      label: "Confirmación de contrasenã",
      placeholder: "Confirma su contraseña",
    },
    new_password: {
      label: "Nueva contraseña",
      placeholder: "Ingrese su nueva contraseña",
    },
    new_password_confirm: {
      label: "Confirmación de nueva contraseña",
      placeholder: "Confirme su nueva contraseña",
    },
    email: {
      label: "Correo electrónico",
      placeholder: "contacto@email.com",
    },
    phone: {
      label: "Teléfono",
      placeholder: "(99) 99999-9999",
    },
    website: {
      label: "Sitio web",
      placeholder: "Ingresa el sitio web de la compañia",
      hint: "Ejemplo: https://www.proveedor.com/",
    },
    logo: {
      label: "Logotipo de la compañía",
      placeholder: "Sube el logotipo",
    },
    agent: {
      label: "Cupón",
      placeholder: "Ingrese su cupón",
    },
    facebook: {
      label: "Facebook",
      placeholder: "Link de Facebook",
      hint: "Ejemplo: https://www.facebook.com/tuprovedor",
    },
    whatsapp: {
      label: "Whatsapp",
      placeholder: "Número do Whatsapp",
      hint:
        "55 (DDD) Número - el enlace de WhatsApp se generará automáticamente.",
    },
    planSite: {
      label: "Página de planes",
      placeholder: "Ingrese el link para la página de planes",
      hint: "Exemplo: https://www.provedor.com/planes",
    },
  },
  user_edit: {
    welcome: "Edite sus datos de usuario a continuación:",
  },
  validators: {
    email: {
      required: "El correo electrónico es obligatorio",
      invalid: "El correo electrónico debe ser válido",
    },
    name: {
      required: "El nombre es obligatorio",
    },
    cnpj: {
      required: "El CNPJ es obligatorio",
      invalid: "El CNPJ debe ser válido",
    },
    password: {
      required: "La contraseña es obligatoria",
      min_length: "La contraseña debe ter al menos {0} caracteres",
      required_characters: (v) => !!v,
    },
    website: {
      required: "El sitio web es obligatorio",
      http: 'Creo que estás olvidando "https://" ou "http://" antes de "www"',
    },
    file: {
      img: "Archivo en formato no compatible.",
    },
    facebook: {
      required: "Facebook es obligatorio",
      http:
        'Vaya ... estás olvidando "https: //" o "http: //" antes de "www.facebook.com"',
      isFacebook:
        'Parece que este no es un sitio de Facebook, use el campo "Sitio web"',
    },
    phone: {
      required: "El teléfono es obligatorio",
      invalid: "El teléfono debe ser válido",
      min_length: "Número no válido",
      only_numbers: "Solo números",
    },
    required: "Campo obligatorio",
  },
  prospect_finish: {
    thank_you: "¡Muchas gracias!",
    contact_soon:
      "Luego te contactaremos en el correo electrónico: <br> <strong>{0}</strong>",
    new_request: "Volver a consultar",
    register: "Quiero que me avisen",
    back: "Nueva consulta",
    question:
      "¿No encontraste lo que querías?¡Deja su contato y te vamos a avisar acerca de las novedades en su región!",
  },
  feedback_component: {
    success_msg: "¡Gracias por tus comentarios!",
    success_title: "Enviado con éxito",
    error_msg:
      "Vuelva a intentarlo más tarde o póngase en contacto con nuestro servicio de asistencia.",
    error_title: "¡Vaya! No pudimos enviar :( ",
  },
  provider_list: {
    list: "Lista de proveedores <br> encontrados",
    listDesktop: "Lista de proveedores encontrados",
    name: "NOMBRE",
    phone: "TELÉFONO",
    website: "SITE",
    precision: "PRECISION",
    error_msg: "No podemos encontrarlo en su región",
    error_title: "Lo siento",
    contact: "Contacto",
    buyNow_title: "CONTRATA AHORA",
    error_buyNow: "No es posible comprar ahora",
  },
  provider_recover: {
    success_title: "Contraseña cambiada.",
    success_msg: "Iniciar sesión con la nueva contraseña",
    error_title: "Error al cambiar la contraseña",
    error_msg:
      "Vuelva a intentarlo más tarde o póngase en contacto con el servicio de asistencia técnica",
    error_title_pass: "Las contraseñas no coinciden",
    error_msg_pass: "Las contraseñas deben ser iguales",
  },
  provider_login: {
    do_login: "Iniciar sesión",
    or_register_your_provider: "o registra tu proveedor",
    register_question: "¿Aún no tienes un registro?",
    register_wanted: "Quiero registrarme",
    toast_error_title: "Error al iniciar sesión",
    toast_error_msg:
      "Verifique que las credenciales se hayan ingresado correctamente.",
    toast_recover_title:
      "Correo electrónico de recuperación de contraseña enviado",
    toast_recover_msg:
      "Verifique la bandeja de entrada del correo electrónico proporcionada.",
    toast_error_recover_title: "Error",
    toast_error_recover_msg: "No se pudo enviar el correo de recuperación.",
  },
  prospect_form: {
    title:
      "Para recibir el resultado, por favor completa las siguientes informaciones.",
    altTitle:
      "¡Deja su contato y le informaremos acerca de las actualizaciones en su región!",
    toast_send_title: "¡Hemos mandado!",
    toast_send_body:
      "La lista de proveedores llegará en su correo electrónico.",
    toast_send_title_alt: "¡Hemos mandado!",
    toast_send_body_alt:
      "Te informaremos si la oferta de proveedores cambia en tu región",
    toast_no_providers_msg:
      "Lo sentimos, no pudimos encontrar ningún proveedor en su área.",
    toast_no_providers_title: "Sin proveedores",
    toast_error_msg:
      "Lo sentimos, se produjo un error al enviar el correo electrónico.",
    toast_error_title: "Vuelve a intentarlo",
    toast_error_msg_mail: "Por favor, si fue escrito correctamente.",
    toast_error_title_mail:
      "Ops... Parece que este correo electrónico no existe :(",
  },

  integrations: {
    ozmapList1: "Importando áreas de cobertura",
    ozmapList2: "Integración continua de nuevas áreas",
    ozmapList3: "Cambio masivo de áreas",
    ozmapText1:
      "Importa las áreas de cobertura alrededor del cuadro, como se define en el radio de cobertura.",
    ozmapText2: "Importando los nuevos cuadros",
    ozmapText3: "Cambio masivo de áreas",
    ozmap: "OZmap",
    ozmapURL: "URL de OZmap",
    ozmapAPIkey: "Clave API - OZmap",
    ozmapAPIkeyHint: "La clave se obtiene del propio OZmap",
    ozmapRadius: "Radio de cobertura alrededor de la caja en metros",
    ozmapRadiusHint:
      "La importación genera un campo alrededor de cada cuadro y lo usa como área de cobertura",
    config_access: "Configuración de acceso",
    integration_options: "Opciones de integración",
    integrate: "Integrar",
    import_areas: "Importar",
    apikey_subheader:
      "Esta clave permite el uso de integraciones, generadas solo una vez.",
    apikey_header: "Generar clave de integración",
    active_integration: "Activar integración",
    options: "Configuración de integración",
    error_key: "error de clave de API",
  },
  prospect_result: {
    title: {
      success: "¡Encontramos proveedores en tu área!",
      failure: "Por el momento no hemos encontramos proveedores en su área",
    },
    subtitle: {
      success: "Para ver la lista, completa las informaciones:",
      failure:
        "Para recibir una alerta cuando estes datos estén disponibles, completa con tus informaciones:",
    },
    fields: {
      email: {
        label: "Correo electrónico",
        placeholder: "contacto@email.com",
      },
      phone: {
        label: "Teléfono",
        placeholder: "(99) 99999-9999",
      },
    },
  },
  prospect_name: {
    name_question: "¿Cual es tu nombre?",
    name_field_placeholder: "Ingresa acá",
  },
  prospect_cancel: {
    option_giveup: "Dejé de buscar.",
    option_other: "Otra razón. ¿Cúal?",
    option_many: "Recibiendo demasiados correos electrónicos.",
    option_contract: "Ya he contratado a un proveedor. ¿Cúal?",
    cancel_inscription: "Cancelar suscripción",
    toast_success_msg: "Ya no recibirás correos electrónicos de QuieroInternet",
    toast_success_title: "Suscripción cancelada correctamente",
    toast_error_msg:
      "Vuelve a intentarlo más tarde o ponte en contacto con el servicio de asistencia",
    toast_error_title: "No se pudo cancelar",
  },
  prospect_location: {
    address_field_placeholder: "Ingresa tu dirección.",
    card_field:
      "¡Hola! Ingresa tu dirección en el espacio arriba y te vamos a encontrar los proveedores en su región.",
    toast_title: "¡Hola!",
    toast_msg:
      "Dirija el puntero a su dirección o escríbalo en la parte superior de la pantalla.",
    toast_srch_title: "Buscamos proveedores cerca de usted.",
    toast_srch_msg: "Esto puede tardar unos pocos segundos.",
    toast_error_title: "Error",
    toast_error_msg: "Lo sentimos, hubo un error al buscar proveedores.",
  },
  provider_config: {
    edit_data: "Editar registro",
    area_list: "Lista de zonas",
  },

  upload_km: {
    welcome:
      "Sube tu archivo de cobertura. Es posible realizar la importación más tarde.",
  },

  stepper: {
    step1: "Usuario",
    step2: "Proveedor",
    step3: "Área de cobertura",
  },

  provider_edit: {
    welcome: "Edite los datos de su proveedor a continuación:",
    area_list: "Lista de áreas",
    toast_error_pass_msg: "Asegúrate de que las dos contraseñas sean iguales",
    toast_error_pass_title: "Las contraseñas no coinciden",
    toast_error_update_msg:
      "Vuelve a intentarlo más tarde y comprueba la información.",
    toast_error_update_title: "Error al actualizar su registro",
    toast_update_msg: "Verifique su información.",
    toast_update_title: "Registro actualizado correctamente",
  },

  provider_register: {
    welcome:
      "Registre los datos de su proveedor que estarán disponibles para sus clientes:",
    chose_after: "Escolher mais tarde",
    chose_plan: "Elegir plan:",
    register: "Registrarse",
    plans: "Planes",
    payment: "Pago",
    impressions: "Impresiones ilimitadas durante 3 meses",
    toast_error_pass_msg: "Asegúrate de que las dos contraseñas sean iguales",
    toast_error_pass_title: "Las contraseñas no coinciden",
    toast_error_update_msg: "Vuelve a intentarlo más tarde.",
    toast_error_update_title: "Error en el registro",
    toast_update_msg: "Ahora es posible iniciar sesión en el sistema.",
    toast_update_title: "Registro exitoso",
    toast_kmz_update_msg: "Ahora es posible excluir áreas que no desea incluir",
    toast_kmz_update_title: "Archivo recibido",
    toast_kmz_error_update_msg:
      "Pero hemos recibido su archivo y nos pondremos en contacto.",
    toast_kmz_error_update_title:
      "¡Vaya! No pudimos crear las áreas automáticamente. ",
    toast_kmz_error_msg: "No pudimos subir su archivo",
    toast_kmz_error_title: "No hay archivos seleccionados",
    toast_error_email_msg:
      "Parece que este correo electrónico ya está registrado",
    toast_error_email_title: "¡Vaya!",
  },

  user_register: {
    toast_error_update_msg: "Vuelve a intentarlo más tarde.",
    toast_error_update_title: "Error en el registro",
    toast_update_msg: "Guardado en el sistema.",
    toast_update_title: "Registro exitoso",
    toast_error_email_msg:
      "Parece que este correo electrónico ya ha sido registrado.",
    toast_error_email_title: "¡Vaya!",
    welcome: "Creemos su nombre de usuario, complete los datos a continuación:",
    toast_login_title: "Iniciar sesión :)",
    toast_login_msg: "Pronto podrás registrar tu proveedor",
  },
  edit_areas: {
    toast_success_msg: "Su área se ha creado correctamente.",
    toast_success_title: "¡Lo logramos!",
    toast_edit_success_msg: "Sus áreas se han editado correctamente.",
    toast_edit_success_title: "¡Lo logramos!",
    toast_save_msg: "Esto no debería tomar mucho tiempo :)",
    toast_save_title: "¡Guardando tu nueva área!",
    toast_error_msg:
      "Vuelve a intentarlo más tarde o ponte en contacto con el servicio de asistencia",
    toast_error_title: "No se pudo crear",
    toast_edit_save_title: "¡Guardando sus nuevas áreas editadas!",
    edit_mode: "Habilitar modo de edición",
    disable_edit_mode: "Desactivar modo de edición",
    search_address: "Dirección de búsqueda",
    instructions_title_mobile:
      "Visualiza tu área en el mapa o mira la lista de arriba.",
    instrucciones_msg_mobile: "",
    instructions_title:
      "Use los botones en la esquina superior derecha para crear y enumerar sus áreas",
    instrucciones_msg: "",
    instrucciones_create_title:
      "Haga clic en el mapa para iniciar un área de cobertura",
    instrucciones_create_msg: "No olvides confirmar más tarde :)",
    instrucciones_edit_title:
      "Haz clic y arrastra los vértices de los polígonos para modificar el área",
    instrucciones_edit_msg: "No olvides confirmar más tarde :)",
    area_size: "Tamaño del área inicial",
    small: "Área pequeña",
    medium: "Área media",
    big: "Área grande",
    list: "Lista",
    add: "Agregar área",
    remove: "Eliminar área",
    edit: "Editar",
    loading_map: "Cargando mapa y áreas de cobertura :)",
  },

  wizard: {
    fail_kmz_msg: "Analizaremos tu archivo y nos comunicaremos contigo",
    fail_kmz_title: "¡Pero no te preocupes!",
  },

  home: {
    find_providers:
      "<b> Encuentre proveedores </b> <br> <i> que atiendan su región. </i>",
    search_now: "Buscar ahora",
  },

  stripe: {
    get_plan:
      "Al adherirse al plan, obtiene acceso a todas las funciones del sistema",
    error_provider_title: "Necesitas un proveedor registrado.",
    error_provider_msg: "Registre su proveedor en la pantalla principal.",
    error_session_title: "¡Vaya! Error al crear la sesión de pago. ",
    error_session_msg: "Comuníquese con nuestro soporte.",
  },

  dash_plans: {
    situation_plan: "Situación del plan",
    no_plan: "Sin plan",
  },

  provider_dashboard: {
    alert:
      "Puede agregar nuevas áreas usando el campo de importación .kmz/.kml a continuación",
    km2: "Km²",
    confirm_action: "Confirmar acción",
    data: "Datos",
    plans: "Planes",
    areas: "Áreas",
    config: "Configuración",
    impressions: "Impresiones",
    montly_data: "Impresiones mensuales",
    search: "Buscar",
    plan_info: "Información del plan",
    plan_basic: "Plan básico",
    label_km: "Carga de archivo kml / kmz",
    impression: "Impresión",
    month_h: "Mes",
    impression_h: "Impresiones",
    field_kmz: "Seleccione su archivo de cobertura",
    name_h: "Nombre",
    created_h: "Fecha de creación",
    active_h: "Activo",
    actions_h: "Acciones",
    toast_area_update_msg: "Modificación realizada.",
    toast_area_update_title: "El área cambió correctamente.",
    toast_area_error_update_msg: "Vuelve a intentarlo más tarde",
    toast_area_error_update_title: "Error al actualizar el área",
    toast_area_delete_msg: "Modificación realizada.",
    toast_area_delete_title: "Área eliminada correctamente.",
    toast_area_error_delete_msg: "Vuelve a intentarlo más tarde",
    toast_area_error_delete_title: "Error al eliminar el área",
    confirm_msg: "Para confirmar, presione el botón de verificación",
    confirm_title: "Confirma tu acción",
    deactivate: "Desactivar",
    activate: "Activar",
    change_status:
      "Cambia el estado de las áreas seleccionadas de activo a inactivo o al revés",
    active_msg: "Activar cobertura en esta región.",
    delete: "Eliminar área",
    delete_msg: "Eliminar la región seleccionada",
  },

  contact_form: {
    contact_us: "¿Quieres aparecer en Quero Internet? <br> Contáctanos",
  },

  areas_dashboard: {
    options: "Opciones",
    saved_areas_msg: "Las áreas de servicio se guardaron correctamente :)",
    saved_areas_title: "Guardado correctamente",
    delete_areas_msg: "Áreas de cobertura eliminadas con éxito :)",
    delete_areas_title: "Eliminado con éxito",
    cities_covered: "Ciudades servidas",
  },

  impressions: "Impresiones",
  impressions_map: "Mapa de impresiones",
  impressions_map_sub:
    "Los punteros son una estimación de dónde se vio su proveedor.",
  data: "Datos",
  plans: "Planes",
  areas: "Áreas",
  error: "Error",
  areas_map: "Mapa de cobertura",
  config: "Configuración",
  search: "Buscar",
  map_pointer: "Puntos",
  map_cluster: "Cluster",
  search_alt: "Buscar",
  country: "País",
  click: "Clic",
  support: "Soporte",
  support_msg: "Contáctenos en el correo electrónico:",
  january: "Enero",
  february: "Febrero",
  march: "Marzo",
  april: "Abril",
  may: "Mayo",
  enter: "Iniciar sesión",
  june: "Junho",
  july: "Julio",
  august: "Agosto",
  september: "Septiembre",
  october: "Octubre",
  november: "Noviembre",
  december: "Diciembre",
  person: "Individual",
  company: "Empresa",
  date_h: "Fecha",
  email_h: "Correo electrónico",
  coord_h: "Lat / Lng",
  type_h: "Tipo",
  phone_h: "Número",
  address_h: "Dirección",
  city_h: "Ciudad",
  cep_h: "CEP",
  month_h: "Mes",
  impression_h: "Impresiones",
  access: "Acceso",
  buyNow: "Contrata",
  buyNow_plans: "Ver planos",
  change_plan: "Cambiar plan",
  field_kmz: "Seleccione su archivo de cobertura",
  name_h: "Nombre",
  created_h: "Fecha de creación",
  active_h: "Activo",
  actions_h: "Acciones",
  toast_area_update_msg: "Modificación realizada.",
  toast_area_update_title: "El área cambió correctamente.",
  toast_area_error_update_msg: "Vuelve a intentarlo más tarde",
  toast_area_error_update_title: "Error al actualizar el área",
  toast_area_delete_msg: "Modificación realizada.",
  toast_area_delete_title: "Área eliminada correctamente.",
  toast_area_error_delete_msg: "Vuelve a intentarlo más tarde",
  toast_area_error_delete_title: "Error al eliminar el área",
  confirm_msg: "Para confirmar, presione el botón de verificación",
  confirm_title: "Confirma tu acción",
  deactivate: "Desactivar",
  activate: "Activar",
  deactivate_msg: "Deshabilitar la cobertura en esta región.",
  active_msg: "Activar cobertura en esta región.",
  delete: "Eliminar área",
  delete_msg: "Eliminar la región seleccionada",
  motive: "Motivo de la cancelación",
  provider: "Proveedor",
  payment_success:
    "¡Listo! Recibirás la confirmación del pago en tu correo electrónico y pronto podrás utilizar la funcionalidad de QueroInternet! ",
  payment_redirect: "Lo estamos redirigiendo a la página de inicio de sesión.",
  payment_canceled: "Pago cancelado.",
  checkout: "Checkout",
  no_info: "No informado",
  after: "Después",
  impression: "impresión",
  select: "Seleccione",
  logout: "Salir",
  welcome: "¡Bienvenido(a)!",
  send: "Enviar",
  confirm: "Confirmar",
  searching: "Estoy buscando internet",
  contact_us: "Contáctanos",
  register: "Quiero registrarme",
  im_company: "Soy una Compañia",
  im_provider: "Soy un Proveedor de Internet",
  im_person: "Soy una Persona Física",
  did_you_know:
    "¿SABÍAS TU QUE HAY MÁS DE 10 MIL <br>  proveedores DE INTERNET?",
  did_you_know_mobile:
    "¿SABÍAS TU QUE HAY MÁS <br> DE 10 MIL proveedores DE <br> INTERNET?",
  help_description:
    "QueroInternet te ayuda a conocer <br> y encontrar alternativas de internet <br> en tu área.",
  help_description_mobile:
    "QueroInternet te ayuda a <br> conocer y encontrar alternativas <br> de internet en tu área.",
  click_below:
    "¡Haz un clic acá abajo y <br> haga una consulta <br> gratis ahora! ",
  click_right:
    "¡Haz un clic al lado y haga una <br> consulta gratis ahora!<br> >> ",
  looking_for_internet: "Estoy buscando internet",
  access_points: "Puntos de cobertura",
  coverage_area: "Área de cobertura",
  coverage: "Cobertura",
  by_month: "por mes",
  currency: "US$",
  select_areas: "Selección de áreas para guardar",
  plan1: "START:",
  plan2: "PRO:",
  plan3: "PREMIUM:",
  plan_features: {
    phone_number: "Número de teléfono",
    website: "Enlace al sitio web",
    impressions: "Hasta {number} impresiones",
    cities: "Hasta {number} ciudad | Hasta {number} ciudades ",
    whatsapp: "Enlace a whatsapp",
    facebook: "Enlace a facebook",
    dashboard: "Acceso al tablero",
    heat_map:
      "Mapa de calor con <br> pedidos dentro y <br> alrededor de su red",
  },
  currency_value: "R$ {price}",
  month: "mes",
  subscribe_plan: "Plan de suscripción",
  subscribe: "Suscribir",
  $vuetify: {
    dataIterator: {
      rowPerPageText: "Elementos por página:",
      itemsPerPageText: "Elementos por página:",
      pageText: "{0} - {1} de {2}",
      noDataText: "No hay datos en este momento",
      noResultsText: "No hay datos en este momento",
    },

    dataTable: {
      rowPerPageText: "Elementos por página:",
      itemsPerPageText: "Elementos por página:",
      pageText: "{0} - {1} de {2}",
      sortBy: "Ordenar por",
      noDataText: "No hay datos en este momento",
    },
    dataFooter: {
      rowPerPageText: "Elementos por página:",
      itemsPerPageText: "Elementos por página:",
      itemsPerPageAll: "Todos",
      pageText: "{0} - {1} de {2}",
      noDataText: "No hay datos en este momento",
    },
    noDataText: "No hay datos en este momento",
  },
  whatsappText:
    "Hola, te conocí en QuieroInternet y me gustaría más información sobre los planes disponibles para la dirección: {address}",
};
